import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noResult: {
		id: 'autodev.agent-picker.picker-content.empty-agent-result',
		defaultMessage: "We didn't find any matches for your search.",
		description:
			'The text that is displayed when search result is not found when user searches agents using some text.',
	},
});
